<svg height="0" width="0">
  <defs>
    <clipPath id="clip_path_left" clipPathUnits="objectBoundingBox">
      <path
        d="M0,0 H0.963 C0.987,0,1,0.022,0.999,0.045 L0.857,0.593 C0.855,0.604,0.847,0.613,0.837,0.617 L0,1 V0"
        fill="white"
      />
    </clipPath>
  </defs>
</svg>

<svg height="0" width="0">
  <defs>
    <clipPath id="clip_path_right" clipPathUnits="objectBoundingBox">
      <path
        d="M1,0 H0.047 C0.02,0.002,0,0.024,0.006,0.048 L0.147,0.615 C0.15,0.625,0.157,0.634,0.168,0.64 L1,1 V0.069"
        fill="white"
      />
    </clipPath>
  </defs>
</svg>

<lib-link *ngIf="offerLink; else noButtonLink" [link]="offerLink" (onClick)="onOfferClick()">
  <ng-container *ngTemplateOutlet="offerBoxLight"></ng-container>
</lib-link>

<ng-template #noButtonLink>
  <ng-container *ngTemplateOutlet="offerBoxLight"></ng-container>
</ng-template>

<ng-template #offerBoxLight>
  <div class="offer-box-light-wrapper h-full" [ngClass]="{ 'md:mt-20': styleSide === 'right' }">
    <div *ngIf="offer?.slices && offer?.slices?.length > 0">
      <ng-container *ngFor="let slice of offer.slices">
        <lib-offer-sticker
          [width]="'md:w-11/12 w-10/12'"
          [margin]="styleSide === 'right' ? 'ml-auto' : ''"
          [borderRadius]="styleSide === 'right' ? 'promo-banner-left-rounded' : 'promo-banner-right-rounded'"
          [fontSize]="'offer-box-light-font-size'"
          *ngIf="slice.type === 'promo_banner'"
          [slice]="$any(slice)"
        >
        </lib-offer-sticker>
      </ng-container>
    </div>
    <div
      class="relative flex flex-col bg-white pt-5 text-color-product-box-description offer-box-light"
      [ngClass]="{ 'offer-box-light-left': styleSide === 'left', 'offer-box-light-right': styleSide === 'right' }"
    >
      <ngx-dynamic-hooks
        *ngIf="offer?.useCustomContent || offer?.useCustomContent === null; else noCustomContent"
        data-source="prismic"
        [content]="offer?.content"
        [options]="{ sanitize: false }"
        class="flex flex-col"
        [ngClass]="{ 'w-11/12': styleSide === 'left', 'float-right text-right pl-14': styleSide === 'right' }"
      >
      </ngx-dynamic-hooks>
      <ng-template #noCustomContent>
        <div [class]="containerCssClass">
          <div data-source="prismic" [innerHtml]="offer.title" [class]="titleCssClass"></div>
          <div
            *ngIf="offer.checkMarks"
            [ngClass]="{
              'ml-auto pl-14': offer.contentAlignment === 'right',
              'pr-12': offer.contentAlignment === 'left',
            }"
          >
            <ng-container *ngFor="let checkMark of offer.checkMarks">
              <div class="flex mb-2 items-center">
                <img style="width: 1.5rem" src="check-mark-yallo" />
                <div class="check" data-source="prismic" [innerHtml]="checkMark"></div>
              </div>
            </ng-container>
          </div>
          <div class="mb-2" data-source="prismic">
            <span [class]="priceFontSize" *ngIf="offer.pricePrefix">{{ offer.pricePrefix }}</span>
            <span [class]="priceFontSize" *ngIf="!offer.promoPrice; else promoPrice">
              {{ offer.normalPrice }}
            </span>
            <ng-template #promoPrice>
              <span [class]="priceFontSize">
                <span class="text-red"> {{ offer.promoPrice }}</span>
                <small>
                  <span class="crossed-out"> {{ offer.normalPrice }}</span></small
                >
              </span>
            </ng-template>
          </div>
          <div data-source="prismic" [innerHtml]="offer.textAfterPrice"></div>
        </div>
      </ng-template>
      <div *ngIf="offer?.slices && offer?.slices?.length > 0" class="flex flex-col mt-3">
        <ng-container *ngFor="let slice of offer.slices">
          <div *ngIf="slice.type === 'count_down'" class="mt-2">
            <lib-offer-box-count-down
              [slice]="$any(slice)"
              [isOfferBoxLight]="true"
              [ngClass]="{ 'float-right': styleSide === 'right' }"
            >
            </lib-offer-box-count-down>
          </div>
          <div *ngIf="slice.type === 'offer_cta'">
            <lib-offer-box-button [slice]="$any(slice)" [isHeroOffer]="isHeroOffer" [offerBoxSide]="styleSide">
            </lib-offer-box-button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>
